import React from 'react'

import Page from 'components/Page'

const _404 = () => (
  <Page title="Page not found">
    <p>Page not found</p>
  </Page>
)

export default _404
